import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import "react";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ErrorFallbackImage_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ErrorFallbackImage_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const ErrorFallbackImage = (t0)=>{
    const $ = c(26);
    let props;
    if ($[0] !== t0) {
        props = _extends({}, t0);
        $[0] = t0;
        $[1] = props;
    } else props = $[1];
    let t1;
    let t10;
    let t11;
    let t12;
    let t13;
    let t14;
    let t15;
    let t16;
    let t17;
    let t18;
    let t19;
    let t2;
    let t20;
    let t21;
    let t22;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ jsx("path", {
            d: "M69.1843 88.2444C74.5851 57.6152 103.793 37.1635 134.422 42.5642L226.349 58.7733C256.978 64.1741 277.43 93.3821 272.029 124.011C266.628 154.641 237.42 175.092 206.791 169.692L114.865 153.482C84.2353 148.082 63.7835 118.874 69.1843 88.2444Z",
            fill: "#99BCFF"
        });
        t2 = /*#__PURE__*/ jsx("path", {
            d: "M133.986 95.1435L127.35 98.1466C126.023 87.8506 120.272 81.8446 113.07 82.5145C113.07 81.8061 112.55 79.9289 113.499 79.4999C120.763 74.4847 128.677 72.1466 133.986 72.1466V95.1435Z",
            fill: "#EDF3FF"
        });
        t3 = /*#__PURE__*/ jsx("path", {
            d: "M133.986 71.6466C134.262 71.6467 134.486 71.8705 134.486 72.1466V95.1437C134.486 95.34 134.371 95.5178 134.192 95.5988L127.556 98.6017C127.412 98.667 127.245 98.6603 127.107 98.5832C126.968 98.5059 126.874 98.3673 126.854 98.2101C126.2 93.1354 124.461 89.1666 122.046 86.5578C119.64 83.9587 116.551 82.6924 113.117 83.0119C112.977 83.0248 112.838 82.9786 112.734 82.8839C112.63 82.7893 112.571 82.6553 112.571 82.5148C112.571 82.376 112.543 82.1656 112.507 81.8644C112.473 81.5827 112.435 81.2458 112.429 80.9123C112.423 80.5831 112.447 80.2185 112.559 79.8908C112.669 79.5694 112.875 79.2594 113.233 79.0753C120.559 74.022 128.562 71.6466 133.986 71.6466ZM133.486 72.6535C128.303 72.7944 120.753 75.0998 113.784 79.9113C113.759 79.9283 113.733 79.9429 113.705 79.9552C113.627 79.9907 113.558 80.0588 113.505 80.214C113.448 80.3809 113.424 80.6107 113.429 80.8927C113.434 81.1704 113.466 81.4626 113.5 81.7453C113.51 81.8225 113.518 81.9023 113.528 81.9816C117.093 81.7961 120.294 83.1944 122.78 85.8791C125.261 88.5595 127.013 92.506 127.749 97.4171L133.486 94.8205V72.6535Z",
            fill: "#226DFE"
        });
        t4 = /*#__PURE__*/ jsx("path", {
            d: "M127.5 96.9999C122.348 100.787 122.119 104.694 125 109.5C114.903 113.075 110.499 125 110.499 137C93.4471 123.389 87.116 96.2927 112.657 80.7579C119.358 79.5025 127 88.4999 127.5 96.9999Z",
            fill: "#D8E5FF"
        });
        t5 = /*#__PURE__*/ jsx("path", {
            d: "M233.748 133.567C234.499 122 230.499 115 217.499 109.5C218.442 102.819 216.881 98.9399 209.597 94.3931C210.107 83.1347 212.999 76.9999 219.964 76.9999C253.1 94.3931 248.542 119.45 233.748 133.567Z",
            fill: "#D8E5FF"
        });
        t6 = /*#__PURE__*/ jsx("path", {
            d: "M112.565 80.2665C116.167 79.5916 119.916 81.6767 122.777 84.8876C125.651 88.1143 127.741 92.5929 127.998 96.9706C128.008 97.1397 127.932 97.3029 127.795 97.4032C125.279 99.2535 124.043 101.075 123.731 102.95C123.418 104.833 124.016 106.887 125.428 109.243C125.505 109.372 125.521 109.528 125.47 109.669C125.419 109.81 125.308 109.922 125.166 109.972C115.383 113.436 110.999 125.059 110.999 137C110.999 137.192 110.889 137.367 110.716 137.45C110.543 137.533 110.338 137.51 110.188 137.391C101.568 130.51 95.6369 120.208 95.1068 109.626C94.5752 99.0116 99.482 88.1862 112.397 80.331L112.478 80.2909C112.506 80.2801 112.535 80.2721 112.565 80.2665ZM122.031 85.5536C119.296 82.4839 115.912 80.703 112.836 81.2343C100.271 88.9093 95.5942 99.3768 96.1048 109.575C96.6018 119.5 102.016 129.235 110.011 135.953C110.256 124.46 114.559 113.045 124.271 109.239C123.005 106.981 122.402 104.848 122.744 102.786C123.104 100.623 124.487 98.6521 126.981 96.7655C126.671 92.7257 124.718 88.571 122.031 85.5536ZM219.963 76.4999C220.044 76.4999 220.124 76.52 220.196 76.5575C236.858 85.3037 244.149 96.037 245.326 106.456C246.502 116.856 241.569 126.795 234.093 133.929C233.944 134.071 233.723 134.107 233.536 134.02C233.35 133.933 233.236 133.741 233.249 133.535C233.621 127.814 232.813 123.292 230.362 119.531C227.906 115.764 223.757 112.691 217.305 109.961C217.096 109.873 216.973 109.654 217.004 109.43C217.469 106.137 217.305 103.614 216.186 101.369C215.063 99.1161 212.942 97.0701 209.332 94.8173C209.179 94.7217 209.089 94.5504 209.097 94.37C209.353 88.7204 210.208 84.2754 211.924 81.2294C212.787 79.6979 213.874 78.5087 215.221 77.705C216.568 76.9009 218.147 76.5 219.963 76.4999ZM219.841 77.5009C218.23 77.5184 216.874 77.8827 215.734 78.5634C214.563 79.2618 213.59 80.3103 212.795 81.7196C211.225 84.5066 210.38 88.6611 210.111 94.1269C213.641 96.3628 215.866 98.4871 217.08 100.924C218.281 103.332 218.458 105.975 218.043 109.191C224.396 111.926 228.639 115.057 231.2 118.985C233.615 122.692 234.492 127.047 234.309 132.308C241.106 125.408 245.417 116.154 244.333 106.568C243.207 96.6034 236.236 86.1369 219.841 77.5009Z",
            fill: "#226DFE"
        });
        t7 = /*#__PURE__*/ jsx("path", {
            d: "M220.499 76.9999V77.4999C213.237 77.5994 210.011 83.0648 208.578 93.9999L203.025 89.3274C201.378 78.089 203.999 74.9813 211.517 71.9999L220.499 76.9999Z",
            fill: "#EDF3FF"
        });
        t8 = /*#__PURE__*/ jsx("path", {
            d: "M211.44 71.5058C211.549 71.4887 211.662 71.5086 211.76 71.5634L220.743 76.5634C220.901 76.6516 220.999 76.8185 220.999 76.9999V77.4999C220.999 77.7734 220.78 77.9962 220.506 77.9999C217.028 78.0476 214.56 79.3659 212.764 81.9706C210.94 84.6154 209.788 88.6179 209.074 94.0653C209.05 94.2463 208.928 94.3996 208.758 94.4657C208.588 94.5317 208.395 94.5003 208.255 94.3827L202.704 89.7099C202.61 89.6312 202.549 89.5211 202.531 89.4003C201.704 83.761 201.924 80.0331 203.395 77.328C204.873 74.6094 207.556 73.0329 211.332 71.5351L211.44 71.5058ZM211.483 72.5526C207.868 74.0068 205.548 75.4635 204.274 77.8065C202.981 80.1834 202.706 83.5792 203.494 89.0683L208.206 93.0331C208.934 87.9855 210.087 84.0908 211.941 81.4022C213.763 78.7606 216.243 77.3107 219.551 77.0438L211.483 72.5526Z",
            fill: "#226DFE"
        });
        t9 = /*#__PURE__*/ jsx("path", {
            d: "M172.613 135L131.815 116.187V107.074L127.999 105.384V47.695L172.65 27.9999L213.999 47.695V96.7856L209.303 103.841V108.544L207.248 109.549V118.538L172.613 135Z",
            fill: "#EDF3FF"
        });
        t10 = /*#__PURE__*/ jsx("path", {
            d: "M132.315 115.865L172.117 134.22C172.127 131.946 172.137 129.446 172.148 126.791L132.315 107.864V115.865ZM173.148 126.789C173.137 129.44 173.127 131.936 173.117 134.207L206.748 118.222V110.35L173.148 126.789ZM128.499 105.058L132.017 106.617L132.03 106.622L172.152 125.686C172.193 114.463 172.187 100.386 172.17 89.0165C172.162 83.1981 172.15 78.089 172.141 74.4345C172.136 72.6072 172.132 71.1434 172.129 70.1366C172.128 69.6332 172.127 69.2437 172.126 68.9804C172.126 68.9508 172.125 68.9228 172.125 68.8964L128.499 48.4813V105.058ZM173.125 68.8847C173.125 68.9136 173.126 68.9445 173.126 68.9774C173.127 69.2408 173.128 69.6302 173.129 70.1337C173.132 71.1406 173.136 72.6042 173.141 74.4315C173.15 78.0863 173.162 83.1959 173.17 89.0145C173.187 100.379 173.193 114.45 173.152 125.674L208.803 108.231V103.841C208.803 103.742 208.832 103.645 208.887 103.563L213.499 96.6347V48.5077L173.125 68.8847ZM154.368 108.592C154.485 108.342 154.782 108.234 155.033 108.35L167.211 114.047C167.461 114.164 167.569 114.462 167.452 114.712C167.335 114.962 167.038 115.07 166.787 114.953L154.61 109.256C154.36 109.139 154.252 108.842 154.368 108.592ZM132.548 102.284C132.667 102.035 132.966 101.93 133.215 102.049L144.175 107.305C144.424 107.424 144.53 107.723 144.41 107.972C144.291 108.22 143.992 108.325 143.743 108.206L132.784 102.951C132.535 102.832 132.429 102.533 132.548 102.284ZM129.207 47.7079L172.616 68.0224L212.864 47.7079L172.641 28.5487L129.207 47.7079ZM214.499 96.786C214.499 96.8844 214.47 96.9805 214.415 97.0624L209.803 103.991V108.544C209.803 108.735 209.694 108.909 209.523 108.993L207.748 109.86V118.538C207.748 118.731 207.637 118.907 207.463 118.99L172.828 135.451C172.695 135.515 172.539 135.516 172.405 135.454L131.606 116.641C131.429 116.559 131.315 116.382 131.315 116.186V107.398L127.797 105.842C127.616 105.762 127.499 105.582 127.499 105.384V47.6952C127.499 47.4972 127.616 47.3172 127.797 47.2372L172.448 27.5429C172.581 27.4841 172.733 27.4861 172.865 27.5487L214.214 47.244C214.388 47.327 214.499 47.5024 214.499 47.6952V96.786Z",
            fill: "#226DFE"
        });
        t11 = /*#__PURE__*/ jsx("path", {
            d: "M167.999 108L131.999 91.0157V55.9999L167.999 72.8992V108Z",
            fill: "white"
        });
        t12 = /*#__PURE__*/ jsx("path", {
            d: "M131.731 55.578C131.875 55.4863 132.057 55.475 132.212 55.5478L168.212 72.4462C168.388 72.5286 168.499 72.7055 168.499 72.8993V108C168.499 108.171 168.411 108.33 168.267 108.422C168.122 108.513 167.941 108.525 167.786 108.452L131.786 91.4677C131.611 91.3851 131.499 91.209 131.499 91.0155V55.9999C131.499 55.829 131.587 55.6698 131.731 55.578ZM132.499 90.6981L167.499 107.211V73.2157L132.499 56.786V90.6981Z",
            fill: "#226DFE"
        });
        t13 = /*#__PURE__*/ jsx("path", {
            d: "M136.738 65.5741C136.973 65.4294 137.281 65.503 137.426 65.7382L140.201 70.2489L142.724 68.5858C142.954 68.4339 143.264 68.498 143.416 68.7284C143.568 68.9589 143.505 69.2687 143.275 69.4208L140.725 71.1015L142.962 74.7382C143.107 74.9734 143.033 75.281 142.798 75.4257C142.563 75.5702 142.255 75.4967 142.111 75.2616L139.89 71.6522L137.275 73.3778C137.044 73.5298 136.734 73.4665 136.582 73.2362C136.43 73.0057 136.493 72.6949 136.724 72.5429L139.366 70.7997L136.574 66.2616C136.429 66.0265 136.503 65.7188 136.738 65.5741Z",
            fill: "#226DFE"
        });
        t14 = /*#__PURE__*/ jsx("path", {
            d: "M155.134 74.5663C155.374 74.4292 155.679 74.5123 155.816 74.7519L158.224 78.9579L160.712 77.2138C160.938 77.0553 161.25 77.11 161.409 77.3358C161.567 77.5619 161.513 77.8745 161.286 78.0331L158.724 79.83L160.97 83.7519C161.107 83.9913 161.025 84.2962 160.785 84.4335C160.546 84.5707 160.24 84.4876 160.103 84.2479L157.903 80.4062L155.286 82.2411C155.06 82.3995 154.749 82.3441 154.59 82.1181C154.432 81.892 154.486 81.5803 154.712 81.4218L157.403 79.5341L154.949 75.2479C154.812 75.0084 154.895 74.7035 155.134 74.5663Z",
            fill: "#226DFE"
        });
        t15 = /*#__PURE__*/ jsx("path", {
            d: "M137.7 88.1C139.329 86.8783 141.28 86.5548 143.265 86.7934C145.245 87.0313 147.284 87.8294 149.147 88.8861C151.012 89.9443 152.724 91.2752 154.05 92.6059C155.362 93.9224 156.348 95.2888 156.685 96.4271C156.763 96.6919 156.612 96.9708 156.347 97.0492C156.082 97.1274 155.804 96.976 155.726 96.7113C155.46 95.8149 154.618 94.5927 153.341 93.3119C152.078 92.0449 150.439 90.7692 148.654 89.7562C146.866 88.7417 144.954 88.0039 143.146 87.7865C141.343 87.5699 139.67 87.8717 138.299 88.8998C138.078 89.0654 137.765 89.0211 137.599 88.8002C137.433 88.5793 137.479 88.2657 137.7 88.1ZM145.362 77.4603C145.637 77.4745 145.849 77.7091 145.835 77.9848C145.674 81.1153 147.101 82.9978 148.363 83.4721C148.978 83.7033 149.547 83.6106 149.971 83.2142C150.416 82.7994 150.79 81.9701 150.79 80.56C150.79 80.2839 151.013 80.06 151.29 80.06C151.566 80.06 151.789 80.2839 151.79 80.56C151.79 82.1197 151.377 83.2684 150.653 83.9447C149.909 84.6392 148.926 84.7512 148.011 84.4076C146.212 83.7317 144.662 81.3438 144.837 77.934C144.852 77.6583 145.086 77.4463 145.362 77.4603Z",
            fill: "#226DFE"
        });
        t16 = /*#__PURE__*/ jsx("path", {
            d: "M203.536 116C181.484 124.091 166.718 124.279 137.208 117.562C125.87 123.592 123.651 129.964 126.137 143.934C150.195 152.157 184.263 154.853 216.547 142.928C219.15 126.562 214.088 119.084 203.536 116Z",
            fill: "#D8E5FF"
        });
        t17 = /*#__PURE__*/ jsx("path", {
            d: "M203.441 115.509C203.519 115.494 203.599 115.498 203.676 115.52C209.039 117.088 213.077 119.795 215.417 124.251C217.748 128.688 218.351 134.774 217.041 143.007C217.013 143.185 216.89 143.335 216.72 143.397C184.312 155.368 150.125 152.661 125.976 144.407C125.804 144.348 125.677 144.2 125.645 144.021C124.398 137.016 124.308 131.812 126.025 127.583C127.749 123.334 131.257 120.16 136.973 117.12C137.079 117.064 137.202 117.048 137.319 117.074C152.059 120.429 163.082 122.051 173.158 121.834C183.225 121.617 192.374 119.562 203.364 115.53L203.441 115.509ZM203.55 116.525C192.557 120.546 183.337 122.615 173.18 122.834C163.025 123.053 151.959 121.424 137.282 118.091C131.759 121.053 128.534 124.06 126.951 127.959C125.368 131.86 125.39 136.743 126.579 143.555C150.462 151.649 184.145 154.275 216.097 142.558C217.33 134.577 216.693 128.831 214.532 124.716C212.375 120.611 208.66 118.048 203.55 116.525Z",
            fill: "#226DFE"
        });
        t18 = /*#__PURE__*/ jsx("path", {
            d: "M216.631 142.566C218.566 127.487 215.701 121.976 202.999 116.5V115.5C208.737 114 214.602 111 216.999 108.5C231.622 115.711 233.603 121.615 233.499 134C227.656 138.176 223.291 140.644 216.999 143L216.631 142.566Z",
            fill: "#EDF3FF"
        });
        t19 = /*#__PURE__*/ jsx("path", {
            d: "M216.638 108.154C216.789 107.997 217.025 107.955 217.22 108.052C224.561 111.671 228.818 115.005 231.203 119.057C233.587 123.108 234.051 127.8 233.999 134.004C233.998 134.164 233.921 134.314 233.79 134.407C227.919 138.603 223.515 141.093 217.175 143.468C216.978 143.542 216.755 143.484 216.619 143.323L216.249 142.89C216.158 142.782 216.116 142.641 216.134 142.502C217.1 134.979 216.847 129.965 214.861 126.163C212.881 122.373 209.123 119.685 202.801 116.959C202.618 116.88 202.499 116.699 202.499 116.5V115.5C202.499 115.273 202.653 115.074 202.873 115.017C205.705 114.276 208.573 113.164 211.027 111.929C213.489 110.689 215.497 109.344 216.638 108.154ZM217.097 109.108C215.819 110.342 213.813 111.645 211.477 112.821C209.072 114.032 206.281 115.125 203.499 115.883V116.174C209.703 118.882 213.636 121.661 215.747 125.7C217.863 129.752 218.09 134.969 217.153 142.405C223.146 140.133 227.391 137.734 232.999 133.74C233.036 127.692 232.546 123.31 230.341 119.563C228.139 115.82 224.179 112.636 217.097 109.108Z",
            fill: "#226DFE"
        });
        t20 = /*#__PURE__*/ jsx("path", {
            d: "M125.999 144C118.986 141.779 115.211 140.484 110.312 136.97C107.4 124.606 111.66 114.957 123.186 109.941L124.965 109.207C127.999 112.5 132.999 114.5 138.999 117L139.426 118.015C126.525 123.573 123.802 128.42 126.759 143.322L125.999 144Z",
            fill: "#EDF3FF"
        });
        t21 = /*#__PURE__*/ jsx("path", {
            d: "M124.848 108.721C125.022 108.679 125.208 108.734 125.332 108.869C126.793 110.453 128.744 111.745 131.099 112.956C132.867 113.866 134.843 114.721 136.99 115.621L139.192 116.538L139.278 116.584C139.358 116.638 139.422 116.715 139.46 116.806L139.887 117.821C139.993 118.074 139.876 118.365 139.624 118.474C133.186 121.248 129.429 123.791 127.591 127.392C125.751 130.998 125.773 135.784 127.249 143.224C127.284 143.398 127.224 143.577 127.092 143.695L126.332 144.372C126.201 144.49 126.016 144.53 125.848 144.477C118.831 142.254 114.99 140.94 110.021 137.376C109.923 137.306 109.853 137.202 109.826 137.084C108.351 130.823 108.681 125.2 110.882 120.489C113.085 115.774 117.134 112.03 122.987 109.483L122.995 109.479L124.774 108.746L124.848 108.721ZM123.377 110.404C117.709 112.872 113.868 116.46 111.788 120.912C109.727 125.325 109.369 130.645 110.756 136.67C115.45 140.009 119.117 141.291 125.879 143.436L126.214 143.137C124.787 135.829 124.719 130.82 126.701 126.937C128.663 123.092 132.576 120.468 138.774 117.754L138.617 117.382C135.698 116.167 132.992 115.054 130.641 113.845C128.358 112.671 126.38 111.389 124.838 109.8L123.377 110.404Z",
            fill: "#226DFE"
        });
        t22 = /*#__PURE__*/ jsx("path", {
            d: "M173.121 68.8779L213.5 48.5099V96.6377L208.833 103.638V108.226L182.399 121.143C178.525 121.707 173.155 121.845 173.155 121.845L173.121 68.8779Z",
            fill: "#B8CEFA"
        });
        $[2] = t1;
        $[3] = t10;
        $[4] = t11;
        $[5] = t12;
        $[6] = t13;
        $[7] = t14;
        $[8] = t15;
        $[9] = t16;
        $[10] = t17;
        $[11] = t18;
        $[12] = t19;
        $[13] = t2;
        $[14] = t20;
        $[15] = t21;
        $[16] = t22;
        $[17] = t3;
        $[18] = t4;
        $[19] = t5;
        $[20] = t6;
        $[21] = t7;
        $[22] = t8;
        $[23] = t9;
    } else {
        t1 = $[2];
        t10 = $[3];
        t11 = $[4];
        t12 = $[5];
        t13 = $[6];
        t14 = $[7];
        t15 = $[8];
        t16 = $[9];
        t17 = $[10];
        t18 = $[11];
        t19 = $[12];
        t2 = $[13];
        t20 = $[14];
        t21 = $[15];
        t22 = $[16];
        t3 = $[17];
        t4 = $[18];
        t5 = $[19];
        t6 = $[20];
        t7 = $[21];
        t8 = $[22];
        t9 = $[23];
    }
    let t23;
    if ($[24] !== props) {
        t23 = /*#__PURE__*/ jsxs("svg", _object_spread_props(_object_spread({
            width: "340",
            height: "200",
            viewBox: "0 0 340 200",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, props), {
            children: [
                t1,
                t2,
                t3,
                t4,
                t5,
                t6,
                t7,
                t8,
                t9,
                t10,
                t11,
                t12,
                t13,
                t14,
                t15,
                t16,
                t17,
                t18,
                t19,
                t20,
                t21,
                t22
            ]
        }));
        $[24] = props;
        $[25] = t23;
    } else t23 = $[25];
    return t23;
};
export { ErrorFallbackImage };
